module.exports = __webpack_public_path__ + "static/media/1.4b2b35a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80013/1.jpg
// module id = 721
// module chunks = 0